import { render, staticRenderFns } from "./signPage.vue?vue&type=template&id=3bc77e47&scoped=true&"
import script from "./signPage.vue?vue&type=script&lang=ts&"
export * from "./signPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc77e47",
  null
  
)

export default component.exports